import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { Subject } from 'rxjs';
import { GenericErrorResponse } from '../../../../../core/models/generic-response.model';
import { ReferentialsPrestationsService } from '../referentials-prestations.service';
import { MessageService } from 'primeng/api';
import { InlineResponse } from '../../../../../core/models/inline-response.model';
import { TypePrestation } from '../type-prestation.model';
import { HttpErrorResponse } from '@angular/common/http';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { provideTranslocoScope, TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { DropdownModule } from 'primeng/dropdown';
import { ReferentialsUnitsService } from '../../referentials-units/referentials-units.service';
import { Unites } from '../../referentials-units/unites.model';

@Component({
  selector: 'app-add-type-prestation',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, AvatarModule, AvatarGroupModule, DynamicDialogModule, InputTextModule, InputGroupModule, InputGroupAddonModule, ConfirmDialogModule, ReactiveFormsModule, CardModule, ToggleButtonModule, FormsModule, CheckboxModule, ToastModule, TranslocoModule, DropdownModule],
  providers: [provideTranslocoScope({ scope: 'referentiels' })],
  templateUrl: './add-type-prestation.component.html',
  styleUrl: './add-type-prestation.component.css',
})
export class AddTypePrestationComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  typePrestationFormArray!: FormArray;
  fg!: FormGroup;
  errors: GenericErrorResponse[] = [];
  unites: Unites[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private prestationService: ReferentialsPrestationsService,
    private translocoService: TranslocoService,
    private referentialsUnitsService: ReferentialsUnitsService
  ) {}

  typePrestationForm = this.formBuilder.group({
    codeHecate: ['', [Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
    designation: ['', [Validators.required, Validators.maxLength(50)]],
    transport: [],
    suffisantPourDemande: [],
    afficherSurLaConfirmation: [],
    envoiTennaxia: [],
    unite: [null, [Validators.required]],
  });

  userHasReadWritePermission: boolean = false;

  ngOnInit(): void {
    if (!!this.config.data) {
      this.fg = this.config.data.typePrestationForm;
      this.typePrestationFormArray = this.fg.get('typePrestationFormArray') as FormArray;
      this.userHasReadWritePermission = this.config.data.userHasReadWritePermission;
    }
    this.referentialsUnitsService.getUnitesData().subscribe((data) => {
      this.unites = data;
    });
  }

  addTypePrestation() {
    this.prestationService
      .addTypePrestation(
        this.typePrestationForm.get('afficherSurLaConfirmation')?.value ?? false,
        Number(this.typePrestationForm.get('codeHecate')?.value),
        this.typePrestationForm.get('designation')?.value ?? '',
        this.typePrestationForm.get('envoiTennaxia')?.value ?? false,
        this.typePrestationForm.get('suffisantPourDemande')?.value ?? false,
        Boolean(this.typePrestationForm.get('transport')?.value),
        (this.typePrestationForm.get('unite')?.value as Unites | null)?.id,
      )
      .subscribe({
        next: (data) => {
          this.checkIfTypePrestationSuccessfull(data);
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: this.translocoService.translate('error.popup.titre.defaut'), detail: 'Une erreur est survenue ' + this.errors.map((e) => e.errorMsg), life: 3000 });
        },
      });
  }

  private checkIfTypePrestationSuccessfull(data: InlineResponse) {
    switch (data.success) {
      case true:
        let typePrestation = data.object as TypePrestation;
        this.typePrestationFormArray.push(
          this.formBuilder.group({
            id: [typePrestation.id],
            codeHecate: [typePrestation.codeHecate],
            designation: [typePrestation.designation],
            afficherSurLaConfirmation: [typePrestation.afficherSurLaConfirmation],
            suffisantPourDemande: [typePrestation.suffisantPourDemande],
            transport: [typePrestation.transport],
            envoiTennaxia: [typePrestation.envoiTennaxia],
            unite: [typePrestation.unite],
          }),
        );
        this.close(true);
        break;
      case false:
        this.errors = data.errors.length > 0 ? data.errors : [data.exception];
        this.messageService.add({ severity: 'error', summary: this.translocoService.translate('error.popup.titre.defaut'), detail: 'Une erreur est survenue ' + this.errors.map((e) => e.errorMsg), life: 3000 });
        break;
    }
  }

  close(result: boolean): void {
    this.ref.close(result);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
